// Brand assets provided by the owner
export const ASSETS = {
  // Square circular logo (1254x1254) — primary brand logo
  logoRound: "https://customer-assets-lqy194kg.emergentagent.net/job_coral-fish-market/artifacts/jgsmzp0j_27A04308-4D28-4538-9C16-82306B2F2149.png",
  // Wide marketing banner (1942x809)
  banner: "https://customer-assets-lqy194kg.emergentagent.net/job_coral-fish-market/artifacts/sd0k0nj4_5C70AC53-DE0B-4DEC-859A-294C527DD910.png",
  // Tall services flyer (921x2000)
  flyer: "https://customer-assets-lqy194kg.emergentagent.net/job_coral-fish-market/artifacts/9wyfp2c9_IMG_1044.webp",
  // Tall reef hero with logo (used on home hero)
  hero: "https://customer-assets-lqy194kg.emergentagent.net/job_coral-fish-market/artifacts/i26urhv5_4B9D71E8-B04F-42B7-8A8B-411ACB4F9CCB.png",
};

export const BRAND = {
  name: "Exotic Reefing Inc",
  tagline: "South Florida's Professional Reef Aquarium Specialists",
  slogan: "Turning Reef Tanks Into Masterpieces.",
  phone: "954-868-0608",
  phoneHref: "tel:+19548680608",
  smsHref: "sms:+19548680608",
  instagram: "https://www.instagram.com/exotic_reefing_inc",
  instagramHandle: "@exotic_reefing_inc",
  tiktok: "https://www.tiktok.com/@exotic.reefing",
  // Google Business Profile "write a review" link
  googleReviewUrl: "https://g.page/r/CcaLVKrQdCFWEAE/review",
  serving: "Proudly serving all of South Florida · Residential & Commercial",
};
